import axios from "axios";
import qs from "qs";

//var urlIp = 'http://10.83.2.208:3301';
// var urlIp = 'https://yxgjapi.maimaiti.cn/api';
var urlIp = process.env.API_ROOT;

//设置请求头
axios.interceptors.request.use(function (config) {
    config.headers['Authorization'] = localStorage.getItem('token');
    return config;
}, function(error){
    return Promise.reject(error);
});

/**
 * post请求,数据拼接到链接后面的方式
 */
function httpPostQs(url, data, successBack, errorBack) {
  let allUrl = urlIp + url;
  axios
    .post(allUrl, qs.stringify(data))
    .then(res => {
      let d = res.data;
      if (d.status == 200) {
        if (successBack) successBack(d);
      } else {
        if (errorBack) errorBack(d);
      }
    })
    .catch(err => {
      console.log(err.data);
      // if (errorBack) errorBack(err.data);
    });
}
/**
 * post请求json提交方式(就这方法好使,妈的)
 */
function httpPost(url, data, successBack, errorBack) {
  let allUrl = urlIp + url;
  axios
    .post(allUrl, data)
    .then(res => {
      let d = res.data;
      if (d.status == 200) {
        if (successBack) successBack(d);
      } else {
        if (errorBack) errorBack(d);
      }
    })
    .catch(err => {
      console.log(err);
      let data = err.response.data;
      let rs = null;
      if (data) {
        if (errorBack) errorBack(data);
      }
     
      
    });
}

/**
 * get请求
 */
function httpGet(url, successBack, errorBack) {
  let allUrl = urlIp + url;
  axios
    .get(allUrl)
    .then(res => {
      let d = res.data;
      if (d.status == 200) {
        if (successBack) successBack(d);
      } else {
        if (errorBack) errorBack(d);
      }
    })
    .catch(err => {
      if (errorBack) errorBack(err.data);
      /*
      let data = err.response.data;
      let rs = null;
      if (data) {
        if (errorBack) errorBack(data);
      }
      */
    });
}

/**
 * get请求
 */
function httpGetOpenId(url, successBack, errorBack) {
  let allUrl = urlIp + url;
  axios
    .get(allUrl)
    .then(res => {
      successBack(res);
    })
    .catch(err => {
      console.log(err.data);
      if (errorBack) errorBack(err.data);
    });
}

/**
 * 判断是那个客户端
 */
const versions = (() => {
  var u = navigator.userAgent,
    app = navigator.appVersion;
  return {
    trident: u.indexOf("Trident") > -1, //IE内核
    presto: u.indexOf("Presto") > -1, //opera内核
    webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
    gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
    iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf("iPad") > -1, //是否iPad
    webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
    weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
    qq: u.match(/\sQQ/i) == " qq", //是否QQ
    alipay: u.indexOf("Alipay") > -1 //支付宝app
  };
})();

const tool = {
  domainUrl :"https://uih5.maimaiti.cn", //h5布署的生产域名
  httpPost,
  httpGet,
  httpGetOpenId,
  urlIp,
  httpPostQs,
  versions,
  appId: "",
  alipayAppId: process.env.alipayAppId,
  payType: '', //bank-银行卡支付，alipay-支付宝支付，wechat-微信支付
  custService: '', //是否是客服请求 1=是 

  /**
   * cookie取值
   */
  getCookieValue(name) {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    var c = document.cookie;
    if ((arr = c.match(reg))) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  /**
   * @description 获取url参数
   * @param url
   * @return {{}}
   */
  getUrlParam(url) {
    url = url ? url : window.location.href;
    let _pa = url.substring(url.indexOf("?") + 1),
      _arrS = _pa.split("&"),
      _rs = {};
    for (let i = 0, _len = _arrS.length; i < _len; i++) {
      let pos = _arrS[i].indexOf("=");
      if (pos == -1) {
        continue;
      }
      let name = _arrS[i].substring(0, pos),
        value = window.decodeURIComponent(_arrS[i].substring(pos + 1)).trim().replace(/#\/$/, '');
      _rs[name] = value;
    }
    return _rs
  },

  /**
   * 验证码手机号码
   */
  checkPhone: function(phone) {
    if (!/^1\d{10}$/.test(phone)) {
      return false;
    } else {
      return true;
    }
  },

  /**
   * 校验身份证
   */
  checkICard: function(card) {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(card)) {
      return true;
    } else {
      return false;
    }
  },
  /* 获取appId */
  getAppId: function() {
    tool.wechatSource = tool.getUrlParam().wechatSource || "";
    tool.appId = sessionStorage.getItem(tool.wechatSource) || "";
    tool.payType = sessionStorage.getItem('payType') || "";
    if (tool.appId) return tool.appId;
    if (!tool.wechatSource) return '';
    sessionStorage.setItem('wechatSource', tool.wechatSource)

    
    //alert(tool.wechatSource);
    return axios.get(urlIp + `/ncp/api/weixin/app/get_app_by_code?code=${tool.wechatSource}`).then(({data}) => {
      if(data.isSuccess && data.data){
        tool.appId = data.data.appId;
        tool.payType = '3';
        sessionStorage.setItem(tool.wechatSource, tool.appId);
        sessionStorage.setItem('payType', tool.payType);

        return tool.appId
      }else{
        return ''
      }
    });
  },
  /*
   * 微信、支付宝获取openId、userId
   */
  getPlatInfo: async () => {
    let isWX = tool.versions.weixin;
   
    let isAlipay = tool.versions.alipay;
    if (!isWX && !isAlipay) return Promise.resolve("");

    let utm_param =
      tool.getUrlParam()["utm_param"] ||
      sessionStorage.getItem("utm_param") ||
      "";
    utm_param && sessionStorage.setItem("utm_param", utm_param);
    let code = "";
    let authUrl = "";
    let apiPath = "";
    let curHref = location.href.replace("utm_param=" + utm_param + "&", ""); //授权同意后,redirect本页面,此时会带着code票据
   
    if (isWX) {
      //wx
      debugger
      console.log( tool.getUrlParam())

      let custService = tool.getUrlParam().custService || "";
      console.log("cust====> "+ custService);

      if (custService) {
        sessionStorage.setItem("custService", custService);
      } else {
        sessionStorage.setItem("custService", 0);
      }
      

      code = tool.getUrlParam()["code"];  // 如果用户同意授权，页面将跳转至 redirect_uri/?code=CODE&state=STATE
      
      let wechatSource = sessionStorage.getItem('wechatSource') || this.tool.getUrlParam().wechatSource //这里获取到的是微信配置编码,例如: LYWX
      let appId = sessionStorage.getItem(wechatSource) || "";    // 这里获取到的是 微信的appId,例如:wxbc93141c90da808f

      apiPath = `/ncp/api/weixin/pub_no/h5/get_open_id?code=${code}&wxCode=${wechatSource}`;

      tool.appId = await tool.getAppId()
  
      
      curHref = tool.domainUrl + "/?wechatSource=" + wechatSource +"&custService="+  sessionStorage.getItem("custService");  //这是生产环境域
      debugger
      console.log(curHref)

      authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${tool.appId}&redirect_uri=${encodeURIComponent(curHref)}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
      console.log(authUrl)

    } else /*if (isAlipay)*/ {
      /*
      //alipay
      code = tool.getUrlParam()["auth_code"];
      apiPath = `/oauth/getUserId?auth_code=${code}`;
      authUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${tool.alipayAppId}&scope=auth_user&redirect_uri=${encodeURIComponent(curHref)}`;
      */
      console.log("不支持支付宝或其它浏览器打开页面")
    }

    debugger
    console.log(code+"===="+apiPath);

    if (code && apiPath) {
      return axios.get(urlIp + apiPath).then(res => {
        debugger
        console.log("=======")
        console.log(res.data.data)
        console.log("*******")
        console.log(res.data.data &&  res.data.data.openId)

        if (res.data.data && res.data.data.openId) {
          console.log("res.data.openId: " + res.data.data.openId)

          sessionStorage.setItem("openId", res.data.data.openId)
          return res.data.data.openId;
        }
        return "";
      });
    } else {
      location.href = authUrl;
    }
  },
  alipayApiReady(callback) {
    if (window.AlipayJSBridge) {
      callback && callback();
    } else {
      // 如果没有注入则监听注入的事件
      document.addEventListener("AlipayJSBridgeReady", callback, false);
    }
  },
  /* ios 键盘将页面推上去，失去焦点不回落 */
  fixIOSInput: (elRefStrs, vue) => {
    if (tool.versions.ios || tool.versions.iPhone || tool.versions.webApp) {
      vue.$nextTick(() => {
        elRefStrs.forEach(v => {
          let el = vue.$refs[v];
          if (!el) return;
          let bfscrolltop = 0;
          el.addEventListener("focus", () => {
            bfscrolltop =
              document.body.scrollTop || document.documentElement.scrollTop;
          });
          el.addEventListener("blur", () => {
            console.log(bfscrolltop);
            document.body.scrollTop = bfscrolltop;
            document.documentElement.scrollTop = bfscrolltop;
          });
        });
      });
    }
  }
};

export default tool;



// WEBPACK FOOTER //
// ./src/js/tool.js